/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/isScheduler */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/util/isScheduler.mjs";
